import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';
import { useAppStore } from '@/store/app.store';
import { useAuthStore } from '@/store/auth.store';
import VueElementLoading from 'vue-element-loading';
import Navigation from '@/components/Navigation.vue';
import Message from '@/components/Message.vue';
import ScrollToTop from '@/components/ScrollToTop.vue';
import Header from '@/components/Header.vue';
// import SearchBar from './components/SearchBar.vue';
// import 'mapbox-gl/dist/mapbox-gl.css';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const isLoggedIn = computed(() => {
  const authStore = useAuthStore();
  return authStore.isLoggedIn;
});

const isLoading = computed(() => {
  const appStore = useAppStore();
  return appStore.isLoading;
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(VueElementLoading), {
      active: isLoading.value,
      "is-full-screen": true,
      spinner: "line-wave",
      color: "#f4a912",
      size: "128"
    }, null, 8, ["active"]),
    (isLoggedIn.value && !_ctx.$route.meta.hideNavbar)
      ? (_openBlock(), _createBlock(Navigation, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(Message),
    _createElementVNode("div", {
      class: _normalizeClass({ 'with-navbar': !_ctx.$route.meta.hideNavbar })
    }, [
      _createVNode(_component_router_view)
    ], 2),
    _createVNode(ScrollToTop)
  ], 64))
}
}

})